module.exports = __webpack_public_path__ + "assets/img/m2.f17b7f09.png";